/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-03-06 09:47:51
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-03-06 11:02:31
 * @FilePath: \crm-product\src\views\dms\views\rebate\reward-channel-cost-customer\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import detailForm from './form/details.vue';

export default {
  name: 'reward-chanel_cost_customer',
  extends: BasePage,
  data() {
    return {

    };
  },
  components: {
    detailForm,
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {

    modalClick({ val, row }) {
      if (val.code === 'detail') {
        this.formName = 'detailForm';
        this.propsObjInData.row = { feePoolCode: row.feePoolCode };
        this.modalConfig.title = '明细';
        this.openFull();
      }
    },
  },
};
